import { FormConfig } from '../../../models/form-config';
import {
  OfferModification,
  OfferModificationOption,
  PriceFrequency
} from '../../../../core/models/offer/offer-modification.model';
import { FieldConfig } from '../../../models/field-config';
import { FieldType } from '../../../models/field-type';
import { Validator } from '../../../models/validator.enum';
import { LanguageService } from '../../../services/language.service';
import { OfferModificationDestination } from '../../../../core/consts/offer-modification-destination.enum';
import {
  OfferModificationCode
} from '../../../../core/consts/offer-modification-code.enum';
import { OfferModificationsService } from '../../../../core/services/impl/offer-modifications/offer-modifications.service';
import {AcVariantsSectionConfigBase} from '../ac-variants-section/ac-variants-section-config-base';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

export class AcVariantsBeesafeSectionConfigSectionConfig extends AcVariantsSectionConfigBase {

  constructor(private languageService: LanguageService,
              public offerModificationsService: OfferModificationsService,
              private priceFrequency?: PriceFrequency) {
    super(offerModificationsService);
  }

  createConfig(destination: OfferModificationDestination, modifications: OfferModification[], tilesMode: boolean, initialConfig = false): FormConfig {
    let config: FormConfig = {
      formKey: destination,
      fieldsConfig: []
    }

    config.fieldsConfig = [];
    modifications.forEach(modification => config.fieldsConfig.push(...this.createFieldConfig(modification, tilesMode, initialConfig)));

    const vehicleValueFieldConfig = this.createVehicleValueFieldConfig();
    if (this.offerModificationsService.vehicleValueModificationEnabled && vehicleValueFieldConfig) {
      config.fieldsConfig.push(vehicleValueFieldConfig);
    }

    return config;
  }

  private createFieldConfig(modification: OfferModification, tilesMode: boolean, initialConfig: boolean): FieldConfig[] {
    const modificationConfig = this.offerModificationsService.configService.getModificationConfig(<OfferModificationCode>modification.code);
    const configs: any[] = [{
      fieldKey: modification.code,
      type: FieldType.Radio,
      tooltipIconOutlined: true,
      radioInline: true,
      tilesMode: tilesMode,
      validators: [Validator.REQUIRED],
      caption: this.languageService.getDescription(<any[]>modification.labels),
      description: isNotNullOrUndefined(modificationConfig.tooltip) ? modificationConfig.tooltip : null,
      radioConfig: this.createRadioConfigs(modification, initialConfig, this.outsideLabel(modification.code))
    }];
    return configs;
  }

  private outsideLabel(code: string): boolean {
    return code === 'AC'
  }

  private createRadioConfigs(modification: OfferModification, initialConfig: boolean, outsideLabel?: boolean): any[] {
    const {code, options} = modification;
    let radioOptions;
    if (code === OfferModificationCode.TIRES) {
      // TIRES_YES
      const zeroValueOption = modification.options.find(option => option.value === false);
      const selectedOption = modification.options.find(option => option.value === this.offerModificationsService.tiresValue);

      radioOptions = [
        {
          value: zeroValueOption.value,
          label: 'OFFER_MODIFICATIONS.none',
          price: this.getOptionPrice(zeroValueOption),
          disabled: this.offerModificationsService.assistanceStandardOrPremium
        },
        {
          value: 'TIRES_YES',
          label: 'OFFER_MODIFICATIONS.yes',
          price: this.offerModificationsService.assistanceStandardOrPremium ? this.getOptionPrice(zeroValueOption) : this.getOptionPrice(selectedOption)
        }
      ];
    } else if (code === OfferModificationCode.BATTERY) {
      // TIRES_YES
      const zeroValueOption = modification.options.find(option => option.value === false);
      const selectedOption = modification.options.find(option => option.value === this.offerModificationsService.batteryValue);
      radioOptions = [
        {
          value: zeroValueOption.value,
          label: 'OFFER_MODIFICATIONS.none',
          price: this.getOptionPrice(zeroValueOption),
          disabled: this.offerModificationsService.assistanceStandardOrPremium
        },
        {
          value: 'BATTERY_YES',
          label: 'OFFER_MODIFICATIONS.yes',
          price: this.offerModificationsService.assistanceStandardOrPremium ? this.getOptionPrice(zeroValueOption) : this.getOptionPrice(selectedOption)
        }
      ];
    } else {
      radioOptions = options.map(option => ({
        value: option.value,
        label: this.languageService.getDescription(<any[]>option.labels),
        price: this.getOptionPrice(option),
        outsideLabel: outsideLabel
      }))
    }

    if (this.priceFrequency) {
      radioOptions.sort((a, b) => a.price - b.price);
    }

    const modificationConfig = this.offerModificationsService.configService.getModificationConfig(<OfferModificationCode>code);
    if (isNotNullOrUndefined(modificationConfig) && modificationConfig.hasOwnProperty('isOptionRecommended')) {
      radioOptions.forEach(radioOption => radioOption.highlighted = modificationConfig.isOptionRecommended(radioOption.value));
    }

    return radioOptions;
  }

  private getOptionPrice(option: OfferModificationOption): number {
    if (this.priceFrequency) {
      if (option.hasOwnProperty('prices')) {
        const priceForFrequency = option.prices.find(price => price.frequency === this.priceFrequency);
        return priceForFrequency ? priceForFrequency.value : undefined;
      }
      return 0;
    }
    return undefined;
  }
}
